import { c as _c } from "react/compiler-runtime";
import type { TournamentListItem } from "@clutch/auth/actions/tournaments";
import { ArrowRight01Icon, Calendar01Icon, Image01Icon, Location01Icon, UserGroupIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { format } from "date-fns";
import Image from "next/image";
import Link from "next/link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { getSportConfig } from "@/config/sports";
import { formatTournamentCapacityCount } from "@/lib/shared/tournament-capacity";
import { cn } from "@/lib/utils";
const STATUS_DOT_CLASS: Record<TournamentListItem["availability"]["registrationState"], string> = {
  draft: "bg-muted-foreground",
  coming_soon: "bg-sky-500",
  open: "bg-emerald-500",
  closed: "bg-orange-500",
  full: "bg-amber-500",
  hidden: "bg-muted-foreground"
};
type TournamentCardProps = {
  tournament: TournamentListItem;
  href?: string;
  districtLabel?: string | null;
};
export function TournamentCard(t0) {
  const $ = _c(112);
  const {
    tournament: t,
    href,
    districtLabel
  } = t0;
  let T0;
  let T1;
  let T2;
  let T3;
  let actionHref;
  let resolvedDistrictLabel;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== districtLabel || $[1] !== href || $[2] !== t.availability.label || $[3] !== t.availability.registrationState || $[4] !== t.coverImageUrl || $[5] !== t.description || $[6] !== t.districtName || $[7] !== t.districtState || $[8] !== t.endDate || $[9] !== t.maxParticipants || $[10] !== t.name || $[11] !== t.registrationCounts.activeSlots || $[12] !== t.slug || $[13] !== t.sportSlug || $[14] !== t.startDate) {
    const sportConfig = getSportConfig(t.sportSlug);
    const SportIcon = sportConfig.icon;
    actionHref = href ?? `/t/${t.slug}`;
    let t11;
    if ($[31] !== t.startDate) {
      t11 = format(new Date(t.startDate), "MMM d");
      $[31] = t.startDate;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    const start = t11;
    let t12;
    if ($[33] !== t.endDate) {
      t12 = format(new Date(t.endDate), "MMM d, yyyy");
      $[33] = t.endDate;
      $[34] = t12;
    } else {
      t12 = $[34];
    }
    const end = t12;
    const dateRange = `${start} – ${end}`;
    resolvedDistrictLabel = districtLabel ?? (t.districtName ? t.districtState ? `${t.districtName}, ${t.districtState}` : t.districtName : null);
    const availabilityState = t.availability.registrationState;
    const dotClass = STATUS_DOT_CLASS[availabilityState] ?? "bg-muted-foreground";
    T3 = Card;
    t7 = `tournament-card-${t.slug}`;
    t8 = "flex flex-col gap-2 overflow-hidden py-0 transition-colors hover:border-border/80";
    let t13;
    if ($[35] !== t.coverImageUrl || $[36] !== t.name) {
      t13 = t.coverImageUrl ? <Image src={t.coverImageUrl} alt={`${t.name} cover`} fill={true} className="object-cover" unoptimized={true} /> : <div className="flex h-full w-full items-center justify-center text-muted-foreground"><HugeiconsIcon icon={Image01Icon} className="h-8 w-8 opacity-50" /></div>;
      $[35] = t.coverImageUrl;
      $[36] = t.name;
      $[37] = t13;
    } else {
      t13 = $[37];
    }
    let t14;
    if ($[38] !== dotClass) {
      t14 = cn("relative flex h-2 w-2 rounded-full", dotClass);
      $[38] = dotClass;
      $[39] = t14;
    } else {
      t14 = $[39];
    }
    let t15;
    if ($[40] !== availabilityState) {
      t15 = availabilityState === "open" && <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75" />;
      $[40] = availabilityState;
      $[41] = t15;
    } else {
      t15 = $[41];
    }
    let t16;
    if ($[42] !== t14 || $[43] !== t15) {
      t16 = <span aria-hidden={true} className={t14}>{t15}</span>;
      $[42] = t14;
      $[43] = t15;
      $[44] = t16;
    } else {
      t16 = $[44];
    }
    let t17;
    if ($[45] !== t.availability.label) {
      t17 = <span>{t.availability.label}</span>;
      $[45] = t.availability.label;
      $[46] = t17;
    } else {
      t17 = $[46];
    }
    let t18;
    if ($[47] !== t16 || $[48] !== t17) {
      t18 = <div className="absolute top-3 right-3 flex items-center gap-1.5 rounded-full border bg-background/90 px-2.5 py-1 font-medium text-xs backdrop-blur-sm">{t16}{t17}</div>;
      $[47] = t16;
      $[48] = t17;
      $[49] = t18;
    } else {
      t18 = $[49];
    }
    let t19;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
      t19 = <HugeiconsIcon icon={UserGroupIcon} className="h-3.5 w-3.5 text-muted-foreground" />;
      $[50] = t19;
    } else {
      t19 = $[50];
    }
    let t20;
    if ($[51] !== t.maxParticipants || $[52] !== t.registrationCounts.activeSlots) {
      t20 = formatTournamentCapacityCount(t.registrationCounts.activeSlots, t.maxParticipants);
      $[51] = t.maxParticipants;
      $[52] = t.registrationCounts.activeSlots;
      $[53] = t20;
    } else {
      t20 = $[53];
    }
    let t21;
    if ($[54] !== t20) {
      t21 = <div className="absolute top-3 left-3 flex items-center gap-1.5 rounded-full border bg-background/90 px-2.5 py-1 font-medium text-xs backdrop-blur-sm">{t19}<span>{t20}</span></div>;
      $[54] = t20;
      $[55] = t21;
    } else {
      t21 = $[55];
    }
    if ($[56] !== t13 || $[57] !== t18 || $[58] !== t21) {
      t9 = <div className="relative h-48 w-full bg-muted">{t13}{t18}{t21}</div>;
      $[56] = t13;
      $[57] = t18;
      $[58] = t21;
      $[59] = t9;
    } else {
      t9 = $[59];
    }
    let t22;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t22 = <HugeiconsIcon icon={Calendar01Icon} className="h-4 w-4 shrink-0" />;
      $[60] = t22;
    } else {
      t22 = $[60];
    }
    let t23;
    if ($[61] !== dateRange) {
      t23 = <div className="mb-2 flex items-center gap-1.5 text-[13px] text-muted-foreground">{t22}<span className="font-medium text-foreground">{dateRange}</span></div>;
      $[61] = dateRange;
      $[62] = t23;
    } else {
      t23 = $[62];
    }
    let t24;
    if ($[63] !== t.name) {
      t24 = <CardTitle className="line-clamp-1 font-semibold text-xl leading-tight">{t.name}</CardTitle>;
      $[63] = t.name;
      $[64] = t24;
    } else {
      t24 = $[64];
    }
    let t25;
    if ($[65] !== t.description) {
      t25 = t.description && <p className="mt-1.5 line-clamp-2 text-muted-foreground text-sm">{t.description}</p>;
      $[65] = t.description;
      $[66] = t25;
    } else {
      t25 = $[66];
    }
    if ($[67] !== t23 || $[68] !== t24 || $[69] !== t25) {
      t10 = <CardHeader className="p-5 pt-3 pb-3">{t23}{t24}{t25}</CardHeader>;
      $[67] = t23;
      $[68] = t24;
      $[69] = t25;
      $[70] = t10;
    } else {
      t10 = $[70];
    }
    T2 = CardContent;
    t6 = "flex-grow space-y-3 p-5 pt-0 pb-3.5";
    t5 = "flex flex-wrap gap-2";
    T1 = Badge;
    t3 = "secondary";
    t4 = "flex items-center gap-2 px-2.5 py-3.5 font-medium text-sm";
    t2 = "shrink-0";
    T0 = SportIcon;
    t1 = cn("h-4.5 w-4.5", sportConfig.colorConfig.text);
    $[0] = districtLabel;
    $[1] = href;
    $[2] = t.availability.label;
    $[3] = t.availability.registrationState;
    $[4] = t.coverImageUrl;
    $[5] = t.description;
    $[6] = t.districtName;
    $[7] = t.districtState;
    $[8] = t.endDate;
    $[9] = t.maxParticipants;
    $[10] = t.name;
    $[11] = t.registrationCounts.activeSlots;
    $[12] = t.slug;
    $[13] = t.sportSlug;
    $[14] = t.startDate;
    $[15] = T0;
    $[16] = T1;
    $[17] = T2;
    $[18] = T3;
    $[19] = actionHref;
    $[20] = resolvedDistrictLabel;
    $[21] = t1;
    $[22] = t10;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
  } else {
    T0 = $[15];
    T1 = $[16];
    T2 = $[17];
    T3 = $[18];
    actionHref = $[19];
    resolvedDistrictLabel = $[20];
    t1 = $[21];
    t10 = $[22];
    t2 = $[23];
    t3 = $[24];
    t4 = $[25];
    t5 = $[26];
    t6 = $[27];
    t7 = $[28];
    t8 = $[29];
    t9 = $[30];
  }
  let t11;
  if ($[71] !== T0 || $[72] !== t1) {
    t11 = <T0 className={t1} />;
    $[71] = T0;
    $[72] = t1;
    $[73] = t11;
  } else {
    t11 = $[73];
  }
  let t12;
  if ($[74] !== t11 || $[75] !== t2) {
    t12 = <span className={t2}>{t11}</span>;
    $[74] = t11;
    $[75] = t2;
    $[76] = t12;
  } else {
    t12 = $[76];
  }
  let t13;
  if ($[77] !== T1 || $[78] !== t.sportName || $[79] !== t12 || $[80] !== t3 || $[81] !== t4) {
    t13 = <T1 variant={t3} className={t4}>{t12}{t.sportName}</T1>;
    $[77] = T1;
    $[78] = t.sportName;
    $[79] = t12;
    $[80] = t3;
    $[81] = t4;
    $[82] = t13;
  } else {
    t13 = $[82];
  }
  let t14;
  if ($[83] !== t.categoryName) {
    t14 = t.categoryName && <Badge variant="secondary" className="px-2.5 py-3.5 font-medium text-muted-foreground text-sm">{t.categoryName}</Badge>;
    $[83] = t.categoryName;
    $[84] = t14;
  } else {
    t14 = $[84];
  }
  let t15;
  if ($[85] !== resolvedDistrictLabel || $[86] !== t.primaryVenueName || $[87] !== t.venueCount) {
    t15 = resolvedDistrictLabel && <Badge variant="secondary" className="flex max-w-full items-center gap-1.5 px-2.5 py-3.5 font-medium text-muted-foreground text-sm"><span className="shrink-0"><HugeiconsIcon icon={Location01Icon} strokeWidth={2} className="size-4 shrink-0 text-foreground" /></span>{t.primaryVenueName ? <div className="flex min-w-0 items-center gap-1"><span className="truncate text-foreground">{t.primaryVenueName}</span>{t.venueCount > 1 && <span className="shrink-0 text-muted-foreground">+{t.venueCount - 1} more</span>}</div> : <span className="truncate">{resolvedDistrictLabel}</span>}</Badge>;
    $[85] = resolvedDistrictLabel;
    $[86] = t.primaryVenueName;
    $[87] = t.venueCount;
    $[88] = t15;
  } else {
    t15 = $[88];
  }
  let t16;
  if ($[89] !== t13 || $[90] !== t14 || $[91] !== t15 || $[92] !== t5) {
    t16 = <div className={t5}>{t13}{t14}{t15}</div>;
    $[89] = t13;
    $[90] = t14;
    $[91] = t15;
    $[92] = t5;
    $[93] = t16;
  } else {
    t16 = $[93];
  }
  let t17;
  if ($[94] !== T2 || $[95] !== t16 || $[96] !== t6) {
    t17 = <T2 className={t6}>{t16}</T2>;
    $[94] = T2;
    $[95] = t16;
    $[96] = t6;
    $[97] = t17;
  } else {
    t17 = $[97];
  }
  let t18;
  if ($[98] !== actionHref) {
    t18 = {
      pathname: actionHref
    };
    $[98] = actionHref;
    $[99] = t18;
  } else {
    t18 = $[99];
  }
  const t19 = `tournament-card-view-${t.slug}`;
  let t20;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <HugeiconsIcon icon={ArrowRight01Icon} className="ml-2 h-4 w-4" />;
    $[100] = t20;
  } else {
    t20 = $[100];
  }
  let t21;
  if ($[101] !== t18 || $[102] !== t19) {
    t21 = <CardFooter className="mt-auto p-5 pt-0"><Button asChild={true} className="w-full" variant="secondary"><Link href={t18} data-testid={t19}>{"View Details"}{t20}</Link></Button></CardFooter>;
    $[101] = t18;
    $[102] = t19;
    $[103] = t21;
  } else {
    t21 = $[103];
  }
  let t22;
  if ($[104] !== T3 || $[105] !== t10 || $[106] !== t17 || $[107] !== t21 || $[108] !== t7 || $[109] !== t8 || $[110] !== t9) {
    t22 = <T3 data-testid={t7} className={t8}>{t9}{t10}{t17}{t21}</T3>;
    $[104] = T3;
    $[105] = t10;
    $[106] = t17;
    $[107] = t21;
    $[108] = t7;
    $[109] = t8;
    $[110] = t9;
    $[111] = t22;
  } else {
    t22 = $[111];
  }
  return t22;
}